import SchoolProfilePanel from '@components/tenant/SchoolProfilePanel';

const TenantProfile = () => <SchoolProfilePanel variant="page" />;

export default TenantProfile;
